import { DEFAULT_SETTINGS, KEYS } from './consts';

export function makeSettingsService (userConfig) {
  const service = {
    events: userConfig.events.$new(),
    refreshSettings () {
      const presets = userConfig.get(KEYS.PRESETS);
      const showButton = userConfig.get(KEYS.SHOW_BUTTON);
      service.events.trigger('load', {
        presets: JSON.parse(presets),
        showButton
      });
    },
    save (presets, showButton) {
      userConfig.set(KEYS.PRESETS, JSON.stringify(presets));
      userConfig.set(KEYS.SHOW_BUTTON, showButton);
    },
    init () {
      userConfig.onLoad(service.refreshSettings); // note this function may return immediately
    }
  };

  userConfig.registerPreferences(DEFAULT_SETTINGS);

  return service;
}
